import { Component, OnInit, EventEmitter, Output } from '@angular/core';

enum OPERATION {
  PLUS = 'plus',
  MINUS = 'minus',
}

@Component({
  selector: 'app-guests-capture',
  templateUrl: './guests-capture.component.html',
  styleUrls: ['./guests-capture.component.scss'],
})
export class GuestsCaptureComponent implements OnInit {
  showCapture: boolean = false;
  adults: number = 1;
  children: number = 0;
  operation = OPERATION;

  @Output() getAdults = new EventEmitter<number>();
  @Output() getChildren = new EventEmitter<number>();

  constructor() {}

  ngOnInit(): void {}

  onDisplay(event) {
    event.stopPropagation();
    this.showCapture = !this.showCapture;
  }

  closeDropdown() {
    this.showCapture = false;
  }

  onQuantity(type: string, operation: OPERATION) {
    let adjust = 0;
    operation === OPERATION.MINUS ? adjust = adjust - 1 : adjust = adjust + 1;

    if (type === 'adult' && !(this.adults === 1 && operation === OPERATION.MINUS)) {
      this.adults = this.adults + adjust;
      this.getAdults.emit(this.adults);
    }
    if (type === 'children' && !(this.children === 0 && operation === OPERATION.MINUS)) {
      this.children = this.children + adjust;
      this.getChildren.emit(this.children);
    }
  }
}
